import React from "react";
import { useParams } from "react-router-dom";
import ChildComparisonPage from "../pages/1_ChildComparisonPage";

const ComparisonChildRouter = () => {
  const { drilllevel } = useParams();
  return <ChildComparisonPage metricid={drilllevel} />;
};

export default ComparisonChildRouter;
